import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
const blogSlider = {
  _swiperBlogObj: '',

  init() {},

  enableSwiper() {
    this._swiperBlogObj = new Swiper($('.jsSwiper.jsBlog')[0], {
      slidesPerView: 1,
      loop: true,
      autoplay: true,
      spaceBetween: 30,

      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: 'true',
      },
      modules: [Navigation, Pagination, Autoplay],
    });
  },
};
export default blogSlider;



// WEBPACK FOOTER //
// ./scripts/modules/components/_blog-swiper.js